import { useEffect, useState } from 'react';

export function useFullHeightProjectTab() {
  useEffect(() => {
    document.body.classList.add('with-full-height-project-tab');
    return () => document.body.classList.remove('with-full-height-project-tab');
  }, []);
}

export function useHasChildren(ref) {
  const [hasChildren, setHasChildren] = useState(false);

  useEffect(() => {
    const areChildrenPresent = () => ref.current.childElementCount > 0;
    setHasChildren(areChildrenPresent());

    const observer = new MutationObserver(() => setHasChildren(areChildrenPresent()));
    observer.observe(ref.current, { childList: true });

    return () => observer.disconnect();
  }, []);

  return hasChildren;
}
